import { useEffect } from 'react';

const DEFAULT = 'KaziAtlas — AI-Powered Project Management Software';

/**
 * Sets document.title on mount and restores the default on unmount.
 *
 * Page components should call this once near the top of their render:
 *   usePageTitle('Billing');
 *
 * The suffix " — KaziAtlas" is appended automatically so individual call
 * sites just pass the distinguishing part.
 */
export function usePageTitle(title: string | null | undefined): void {
    useEffect(() => {
        if (title) {
            document.title = `${title} — KaziAtlas`;
        }
        return () => {
            document.title = DEFAULT;
        };
    }, [title]);
}
